export const modalTypes = {
  open: 'modal/open',
  close: 'modal/close',
};
